import { createSelector } from "reselect";

//const selectStringSource = state => state.entities.string_resource;
const selectEntityData = state =>
  state.entities.string_resource
    ? Object.values(state.entities.string_resource.data)
    : {};

export const makeSelectStringSource = () =>
  createSelector([selectEntityData], substate => substate);
